/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGlassDoor = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M17 19.143H5C5 20.72 6.343 22 8 22h9c1.657 0 3-1.28 3-2.857V7.41a.107.107 0 0 0-.11-.104h-2.78a.107.107 0 0 0-.11.104zM17 2c1.657 0 3 1.28 3 2.857H8V16.59a.107.107 0 0 1-.11.104H5.11A.107.107 0 0 1 5 16.59V4.857C5 3.28 6.343 2 8 2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgGlassDoor as GlassDoor };
